export const UPDATE_COUNTRY = '/update-account';
